import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxEditorModule } from 'ngx-editor';
import { Editor } from 'ngx-editor';
import { AbstractControl, ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator } from '@angular/forms';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-rich-text',
    imports: [CommonModule, NgxEditorModule, ReactiveFormsModule, TranslateDirective, TranslatePipe],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: RichTextComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: RichTextComponent,
            multi: true
        }
    ],
    templateUrl: './rich-text.component.html',
    styleUrls: ['./rich-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RichTextComponent implements ControlValueAccessor, Validator, OnInit {
  @Input()
  placeholder: string = "";
  @Input()
  height?: string;//='30vh'
  @Input()
  width?: string;//='20vw'
  @Input()
  isText: boolean = false;
  @Input()
  isExpand: boolean = false;
  @Input()
  isDisplay: boolean = false;
  editor: Editor;
  html1 = '';
  html = new FormControl()
  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;

  isEmpty: boolean = false;
  constructor() {
    this.editor = new Editor();
  }

  ngOnInit(): void {
    this.isDisplay ? this.html.disable() : null;
    this.html.valueChanges.subscribe(html => {
      this.isEmpty = false;
      this.registerOnChangeCallback(JSON.stringify(html));
    });
  }
  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    return null;
  }
  writeValue(obj: any): void {
    if (obj) {
      // if (obj == "") { this.isEmpty = true; }
      this.html.setValue(JSON.parse(obj));
    }
    else {
      this.isEmpty = true;
    }
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
  }
  // make sure to destory the editor
  ngOnDestroy(): void {
    this.editor.destroy();
  }
}
